import { render, staticRenderFns } from "./IconSvgCheck.vue?vue&type=template&id=4c7f1df4&scoped=true&"
import script from "./IconSvgCheck.vue?vue&type=script&lang=js&"
export * from "./IconSvgCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7f1df4",
  null
  
)

export default component.exports